import AuthAxios from '../../models/Axios'
import * as Types from '../../constants/actionTypes';
import { LOCAL_URL, API_REQUESTS , AUTH_SERVICE_URL} from '../../helper/constant'
// import RequestDetail from '../../models/requestDetail'


export const REQUEST_LIST_DETAILS = (requestId) => async (dispatch) => {
  try {
    if (!requestId) {
      return dispatch({ type: Types.REQUEST_LIST_DETAILS_ERROR, payload: `Request is not found` })
    }
    const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/getRequestDetails`, {params: {requestId} });
    dispatch({
      type: Types.REQUEST_LIST_DETAILS_SUCCESS,
      payload: response.data && response.data.data
    })
    dispatch({ type: Types.PROGRAM_REQUEST_STAGES, programRequestStages: response.data.data.requestTypeInfo.programWithStageSequenceInfo })
    dispatch({ type: Types.PROGRAM_STAGE_STATUS_LIST, portalStageStatusList: response.data.data.requestTypeInfo.portalStageStatusesInfo })
  } catch (error) {
    if (error.status === 403 && error?.response?.data?.error?.message.includes("unauthorized ")) {
      dispatch({ type: Types.SET_UNAUTHORIZED_ERROR, payload: true })
    } else {
      dispatch({ type: Types.REQUEST_LIST_DETAILS_ERROR, payload: error })
    }
  }
}



/***** Get all the asset list for excel */
export const GET_ASSET_EXCEL_LIST = (requestId) => async (dispatch) => {
  try {
    const assetsExcel = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.ASSET_EXCEL}`, { requestId: requestId });
    dispatch({
      type: Types.EXCEL_ASSET_SUCCESS,
      payload: assetsExcel.data
    });
  } catch (exception) {
    dispatch({
      type: Types.EXCEL_ASSET_ERROR
    })
  }
}

export const GET_EXCEL_AVAILABLITY = (requestId) => async (dispatch) => {
  const filter = JSON.stringify({ "requestId": requestId });
  try {
    const isExcelPresent = await (AuthAxios).axios(`${LOCAL_URL}${API_REQUESTS.EXCEL_AVAILABLE}?where=${filter}`);
    dispatch({
      type: Types.EXCEL_AVAILABLE_SUCCESS,
      payload: isExcelPresent.data
    })
  } catch (exception) {
    dispatch({
      type: Types.EXCEL_AVAILABLE_ERROR
    })
  }
}

export const GET_PORTAL_QRCODES = (payload) => async (dispatch) => {
  try {
    const { currentPage, itemsPerPage, search, portalId, clientId } = payload
    const finalPayload = {
      pId: portalId, cId: clientId, page: (currentPage - 1), size: itemsPerPage,
      keyword: search
    };
    const REQ_URL = `${LOCAL_URL}/requestdetail/getQrcodes`
    const response = await AuthAxios.axios.get(REQ_URL, { params: finalPayload })
    dispatch({
      type: Types.PORTAL_QRCODE_DATA,
      qrCodeRequests: response.data.data
    })
  } catch (error) {
    let message = error.message
    if (!message && error.error) {
      message = error.error.message
    }
    dispatch({ type: Types.PORTAL_QRCODE_ERROR, error: message })
  }
}

export const SAVE_RECURSIVE_REQUEST = (payload) => async (dispatch) => {
  try {
    const { requestTypeId, requestId, portalId, scheduleType } = payload;
    if (!requestTypeId || !requestId || !portalId || !scheduleType) {
      // console.log(`Error Condition`);
    }
    const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.RECURSIVE_REQ_URL}/createRecursiveRequest`, payload);
    return response.data && response.data.data
    // dispatch({
    //   type: Types.ADD_RECURSIVE_REQUEST,
    //   payload: response.data.data
    // })
  } catch (error) {
    let message = error.message
    if (!message && error.error) {
      message = error.error.message
    }
    dispatch({ type: Types.RECURSIVE_REQUEST_ERROR, error: message })
  }
}

/* Get recursive request by requestid */
export const GET_RECURSIVE_REQUEST_INFO = (payload) => async (dispatch) => {
  try {
    const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.RECURSIVE_REQ_URL}/getRecursiveRequestDetails`, { params: payload });
    return response.data && response.data.data
    // dispatch({
    //   type: Types.EXCEL_ASSET_SUCCESS,
    //   payload: response.data && response.data.data
    // });
  } catch (error) {
    let message = error.message
    if (!message && error.error) {
      message = error.error.message
    }
    dispatch({ type: Types.RECURSIVE_REQUEST_ERROR, error: message })
  }
}

/* Get recursive request by requestid */
export const CHECK_RECURSIVE_REQUEST_SITEID = (payload) => async (dispatch) => {
  try {
    const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.RECURSIVE_REQ_URL}/fetchRecursiveRequestSiteId`, payload);
    return response.data && response.data.data
  } catch (error) {
    let message = error.message
    if (!message && error.error) {
      message = error.error.message
    }
    dispatch({ type: Types.RECURSIVE_REQUEST_ERROR, error: message })
  }
}

/* Get recursive request by requestid */
export const GET_PROGRAM_RECURSIVE_REQUEST = (payload) => async (dispatch) => {
  try {
    const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.RECURSIVE_REQ_URL}/getRecursiveRequests`, {params: payload});
    dispatch({
      type: Types.GET_PROGRAM_RECURSIVE_REQUEST,
      payload: response.data && response.data.data
    });
  } catch (error) {
    let message = error.message
    if (!message && error.error) {
      message = error.error.message
    }
    dispatch({ type: Types.RECURSIVE_REQUEST_ERROR, error: message })
  }
}

export const DELETE_RECURSIVE_REQUEST = (payload) => async (dispatch) => {
  try {
    const { id } = payload;
    if (!id) {
      return;
    }
    const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.RECURSIVE_REQ_URL}/deleteRecursiveRequest`, payload);
    return response.data;
  } catch (error) {
    let message = error.message
    if (!message && error.error) {
      message = error.error.message
    }
    dispatch({ type: Types.RECURSIVE_REQUEST_ERROR, error: message })
  }
}

export const ADD_SITEID_RECURSIVE_REQUEST = (payload) => async (dispatch) => {
  try {
    const { id, collectionSiteId } = payload;
    if (!id || !collectionSiteId) {
      return;
    }
    const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.RECURSIVE_REQ_URL}/addSiteIdRecursiveRequest`, payload);
    return response.data.data;
  } catch (error) {
    let message = error.message
    if (!message && error.error) {
      message = error.error.message
    }
    dispatch({ type: Types.RECURSIVE_REQUEST_ERROR, error: message })
  }
}

export const UPDATE_RECURSIVE_REQUEST = (payload) => async (dispatch) => {
  try {
    const { id, portalId } = payload;
    if (!id || !portalId) {
      return;
    }
    const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.RECURSIVE_REQ_URL}/updateRecursiveRequest`, payload);
    return response.data;
  } catch (error) {
    let message = error.message
    if (!message && error.error) {
      message = error.error.message
    }
    dispatch({ type: Types.RECURSIVE_REQUEST_ERROR, error: message })
  }
}

export const TOGGLE_RECURSIVE_REQUEST = (payload) => async (dispatch) => {
  try {
    const { id } = payload;
    if (!id) {
      return;
    }
    const response = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.RECURSIVE_REQ_URL}/toggleRecursiveRequest`, payload);
    return response.data;
  } catch (error) {
    let message = error.message
    if (!message && error.error) {
      message = error.error.message
    }
    dispatch({ type: Types.RECURSIVE_REQUEST_ERROR, error: message })
  }
}

export const NUMBER_REQUEST_EACH_SERVICE_TYPE = (payload) => async (dispatch) => {
  try {

    const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/getAllNumberRequestsOfStatus`, payload);
    dispatch({
      type: Types.NUMBER_REQUEST_EACH_SERVICE_TYPE,
      numRequestEachType: response.data.data
    })
  } catch (error) {
    let message = error.message
    if (!message && error.error) {
      message = error.error.message
    }
    dispatch({ type: Types.RECURSIVE_REQUEST_ERROR, error: message })
  }
}

/** Customer Home: status cards + recently submitted (dedicated API, not getRequests) */
export const HOME_REQUEST_SUMMARY = (payload) => async (dispatch) => {
  try {
    const response = await AuthAxios.axios.post(
      `${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/homeRequestSummary`,
      payload || {},
    );
    const data = response?.data?.data || {};
    dispatch({
      type: Types.NUMBER_REQUEST_EACH_SERVICE_TYPE,
      numRequestEachType: data.statusCounts || [],
    });
    dispatch({
      type: Types.REQUEST_LIST_SUCCESS,
      payload: data.recentlySubmitted || [],
      allRequest: data.recentlySubmitted || [],
    });
    return data;
  } catch (error) {
    let message = error.message;
    if (!message && error.error) {
      message = error.error.message;
    }
    dispatch({ type: Types.RECURSIVE_REQUEST_ERROR, error: message });
  }
}

export const List_NEW_REQUESTS = (payload) => async (dispatch) => {
  try {

    const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/getListNewRequests`, { params: payload });
    dispatch({
      type: Types.List_NEW_REQUESTS,
      listNewRequests: response.data.data
    })
    return response?.data?.data
  } catch (error) {
    let message = error.message
    if (!message && error.error) {
      message = error.error.message
    }
    dispatch({ type: Types.RECURSIVE_REQUEST_ERROR, error: message })
  }
}

export const List_SUBMIITED_REQUESTS = (payload) => async (dispatch) => {
  try {

    const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/getListSubmittedRequests`, { params: payload });
    return response?.data?.data
  } catch (error) {
    let message = error.message
    if (!message && error.error) {
      message = error.error.message
    }
    dispatch({ type: Types.RECURSIVE_REQUEST_ERROR, error: message })
  }
}

export const SET_RECURSIVE_REQUEST_ERROR = (message) => (dispatch) => {
  dispatch({ type: Types.RECURSIVE_REQUEST_ERROR, payload: message })
}

export const GENERATE_TRANSPORT_ORDER = (payload) => async (dispatch) => {
  try {
      const URL = `${AUTH_SERVICE_URL}/portal/users/generateTransportOrder`
      const response = await AuthAxios.axios.post(URL, payload)
      return response.data && response.data.data
  } catch (err) {
      return err
  }
}